import { render, staticRenderFns } from "./FlappyShutterDescription.vue?vue&type=template&id=367bf90e&scoped=true"
import script from "./FlappyShutterDescription.vue?vue&type=script&lang=ts"
export * from "./FlappyShutterDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367bf90e",
  null
  
)

export default component.exports